<script setup lang="ts">
defineOptions({
    compatConfig: { MODE: 3 },
})

const props = defineProps<{
    description: string,
    list: string[]
}>()
</script>

<template>
    <div class="list">
        <div class="mb-1" v-if="props.description">{{ props.description }}</div>
        <ul class="description-list pl-5 list-disc">
            <li v-for="item in props.list" :key="item">{{ item }}</li>
        </ul>
    </div>
</template>
